/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Start_AtInputs */

const cs_form_start_at = /** @type {(inputs: Form_Start_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Začátek`)
};

const en_form_start_at = /** @type {(inputs: Form_Start_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start`)
};

/**
* | output |
* | --- |
* | "Start" |
*
* @param {Form_Start_AtInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_start_at = /** @type {((inputs?: Form_Start_AtInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Start_AtInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_start_at(inputs)
	return cs_form_start_at(inputs)
});